import React from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";

import BreadcrumbLayout from "layouts/BreadcrumbLayout";
import DriverForm from "./driverComponents/DriverForm";

import { useAddDriverMutation } from "store/services/driverApi";

import { useAppMeta } from "hooks";

const DriverCreateScreen = () => {
  const navigate = useNavigate();

  const breadcrumbs = [
    { title: "Drivers", path: "/app/crm/driver/list" },
    { title: "New driver" },
  ];

  const [createDriver, { isLoading: creatingDriver }] = useAddDriverMutation();

  const handleCreateDriver = async (data) => {

   
    
    try {
      const { _id } = await createDriver(data).unwrap();

      
      toast.success("Driver successfully created!");
      navigate(`/app/crm/driver/${_id}/detail`);
    } catch (err) {
      toast.error(err?.data?.message ?? "Couldn't create driver!");
    }
  };

  useAppMeta("New driver");

  return (
    <BreadcrumbLayout breadcrumbs={breadcrumbs} isBusy={creatingDriver}>
      <BreadcrumbLayout.Paper>
        <DriverForm isBusy={creatingDriver} onSubmit={handleCreateDriver} />
      </BreadcrumbLayout.Paper>
    </BreadcrumbLayout>
  );
};

export default DriverCreateScreen;
